'use strict';
import angular from 'angular';
import _ from 'lodash';
import CircularJSON from '../../../scripts/plugins/circular-json';

import workFlowDecisionPropertiesHtmlUrl from '../views/workflowDecisionProperties.html';
import initialStatusHtmlUrl from '../views/initialStatus.html';
import workFlowTaskPropertiesHtmlUrl from '../views/workflowTaskProperties.html';
import wfStatusChangerPropertiesHtmlUrl from '../views/wfStatusChangerProperties.html';
import graphicalWorkflowHtmlUrl from '../views/graphicalWorkflowView.html'; 
import addTaskHtmlUrl from '../../../views/shared/adminTasks.html';

var app = angular.module('workflows.components', []);

app.component('ioGraph', {
    bindings: {
        workflowObj: '=',
        workflowSave: '&',
        closeWorkflow: '&',
        deleteCell: '&'
    },
    templateUrl: graphicalWorkflowHtmlUrl,

    // The controller that handles our component logic
    controller: function($ioAlert, ClusterService, $rootScope, TaskService, QueuesService, IntegrationsService, UserService) {
        var self = this;
        var container, model, graph;
        self.saveHelper = function() {
            self.workflowSave({ workflowData: workflowData });
        }
        self.cancelWorkflowModal = function() {
            self.closeWorkflow();
        }
        self.modalShown = false;

        var workflowData = {
            id: null,
            name: null,
            typeId: null,
            productId: null,
            clusters: [],
            initialStatusId: null,
            workflowStepGroupId: null,
            initialStepId: null,
            hasIoGraph: null,
            ioGraph: null,
            routingRuleSets: [],
            routingRules: [],
            routingConditions: [],
            workflowTasks: [],
            swimlanes: [],
            graphModel: function() {
                return graph.getModel();
            }
        }
        class RoutingRuleSet {
            constructor(id = null, workflow_id = null, workflow_action_id = null, status_id = null, automated = null) {
                this._id = RoutingRuleSet.counter;
                this.id = id;
                this.workflowId = workflow_id;
                this.workflowActionId = workflow_action_id;
                this.statusId = status_id;
                this.automated = automated;
            }

            static get counter() {
                RoutingRuleSet._counter = (RoutingRuleSet._counter || 0) + 1;
                return 'T' + RoutingRuleSet._counter;
            }
        }
        class RoutingRule {
            constructor(id = null, routing_rule_set_id = null, status_id = null, default_rule = null, workflow_step_id = null) {
                this._id = RoutingRule.counter;
                this.id = id;
                this.routingRuleSetId = routing_rule_set_id;
                this.statusId = status_id;
                this.defaultRule = default_rule;
                this.workflowStepId = workflow_step_id;
            }

            static get counter() {
                RoutingRule._counter = (RoutingRule._counter || 0) + 1;
                return 'T' + RoutingRule._counter;
            }
        }
        class WorkflowTask {
            constructor(id = null, workflow_id = null, workflow_action_id = null, routing_rule_id = null, task_id = null, sequence = 1, auto_assign = null, on_demand = null, shared = null) {
                this.id = id;
                this._id = WorkflowTask.counter;
                this.workflowId = workflow_id;
                this.workflowActionId = workflow_action_id;
                this.routingRuleId = routing_rule_id;
                this.taskId = task_id;
                this.sequence = sequence;
                this.autoAssign = auto_assign;
                this.onDemand = on_demand;
                this.shared = shared;
            }
            static get counter() {
                WorkflowTask._counter = (WorkflowTask._counter || 0) + 1;
                return 'T' + WorkflowTask._counter;
            }
        }
        class RoutingCondition {
            constructor(id = null, routing_rule_set_id = null, rule_set_id = null, true_routing_rule_set_id = null, false_routing_rule_set_id = null) {
                this.id = id;
                this.routingRuleSetId = routing_rule_set_id;
                this.ruleSetId = rule_set_id;
                this.trueRoutingRuleId = true_routing_rule_set_id;
                this.falseRoutingRuleId = false_routing_rule_set_id;
            }
        }
        var initWorkflowData = function() {
            workflowData.id = self.workflowObj.workflowInfo.id;
            workflowData.name = self.workflowObj.workflowInfo.name;
            workflowData.typeId = self.workflowObj.workflowInfo.type_id;
            workflowData.productId = self.workflowObj.workflowInfo.product_id;
            workflowData.clusters = self.workflowObj.workflowInfo.cluster_ids;
            workflowData.initialStatusId = self.workflowObj.workflowInfo.initial_status_id;
            workflowData.workflowStepGroupId = self.workflowObj.workflowInfo.workflow_step_group_id;
            workflowData.initialStepId = self.workflowObj.workflowInfo.initial_step_id;
            workflowData.hasIoGraph = self.workflowObj.workflowInfo.has_io_graph;
            workflowData.ioGraph = self.workflowObj.workflowInfo.io_graph;
        }
        initWorkflowData();

        /**
         * Helper function for get status name
         * @param {*} statusId
         */
        var mapStatusName_helper = (statusId) => {
            var statusName = statusId;
            var statusObj = _.find(self.workflowObj.workflowStatus, { id: statusId });
            if (statusObj) {
                statusName = statusObj.name;
            }
            return statusName;
        }

        var cellDelete_helper = (cell) => {
            switch (cell.ioElement) {
                case 'task':
                    break;
                case 'condition':
                    break;
                case 'changer':
                    if (cell.routingRuleSet && cell.routingRuleSet.id) {
                        if (cell.routingRule && cell.routingRule.id) {
                            var ruleObj = {
                                routingRuleId: cell.routingRule.id,
                                type: 'routingRule',
                                workflowData: workflowData,
                                routingRuleSetId: cell.routingRuleSet.id
                            }
                            self.deleteCell({ cellObj: ruleObj });
                        }
                    } else if (cell.routingRule && cell.routingRule.id) {
                        var ruleObj = {
                            routingRuleId: cell.routingRule.id,
                            type: 'routingRule',
                            workflowData: workflowData
                        }
                        self.deleteCell({ cellObj: ruleObj });
                    }

                    break;
                default:

            }
        }

        //styles for swimlane
        const style = [];
        style[mxConstants.STYLE_SHAPE] = mxConstants.SHAPE_SWIMLANE;
        style[mxConstants.STYLE_PERIMETER] = mxPerimeter.RectanglePerimeter;
        style[mxConstants.STYLE_STROKECOLOR] = 'lightgray';
        style[mxConstants.STYLE_FONTCOLOR] = '#ffffff';
        style[mxConstants.STYLE_FILLCOLOR] = '#2ecc71';
        style[mxConstants.STYLE_STARTSIZE] = 30;
        style[mxConstants.STYLE_ROUNDED] = false;
        style[mxConstants.STYLE_FONTSIZE] = 14;
        style[mxConstants.STYLE_FONTSTYLE] = 0;
        style[mxConstants.STYLE_HORIZONTAL] = true;
        style[mxConstants.STYLE_LABEL_BACKGROUNDCOLOR] = 'none';

        // dimensions for swimalne and reactangle
        const symbols = {
            swimlane: {
                width: 300,
                height: 550
            },
            rectangle: {
                width: 100,
                height: 40
            },
            rhombus: {
                width: 75,
                height: 75
            },
            triangle: {
                width: 75,
                height: 75
            }
        }

        // Defines a new class for all icons
        // function mxIconSet(state, forEdge) {
        //     if (state) {
        //         this.images = [];
        //         var graph = state.view.graph;

        //         // Delete
        //         var img = mxUtils.createImage('/client/iotool/app/scripts/plugins/graph-editor/images/delete.png');
        //         img.setAttribute('title', 'Delete');
        //         img.style.position = 'absolute';
        //         img.style.cursor = 'pointer';
        //         img.style.width = '16px';
        //         img.style.height = '16px';

        //         if (forEdge) {
        //             img.style.left = (state.x + state.width - 20) + 'px';
        //             img.style.top = (state.y + 20) + 'px';
        //         } else {
        //             img.style.left = (state.x + state.width) + 'px';
        //             img.style.top = (state.y - 16) + 'px';
        //         }

        //         mxEvent.addGestureListeners(img,
        //             mxUtils.bind(this, function(evt) {
        //                 // Disables dragging the image
        //                 mxEvent.consume(evt);
        //             })
        //         );

        //         //event for delete cell
        //         mxEvent.addListener(img, 'click',
        //             mxUtils.bind(this, function(evt) {
        //                 //delete node confirm popup menu
        //                 $modal.open({
        //                     controller: function($scope, $modalInstance) {
        //                         $scope.cancel = () => {
        //                             $modalInstance.dismiss();
        //                         };
        //                         $scope.confirmDelete = () => {
        //                             $modalInstance.close();
        //                         };
        //                     },
        //                     template: '<div class="modal-body">' +
        //                         '<div>' +
        //                         '<h3>Are you sure you want to delete this node?</h3>' +
        //                         '</div>' +
        //                         '</div>' +
        //                         '<div class="modal-footer">' +
        //                         '<button class="btn btn-primary" ng-click="confirmDelete()">OK</button>' +
        //                         '<button class="btn btn-warning" ng-click="cancel()">Cancel</button>' +
        //                         '</div>',
        //                     backdrop: 'static'
        //                 }).result.then(function() {
        //                     var destroyIcon = new mxIconSet(state);
        //                     destroyIcon.destroy();
        //                     graph.removeCells([state.cell]);
        //                     mxEvent.consume(evt);
        //                     cellDelete_helper(state.cell);
        //                 }, function(cancel) {

        //                 });
        //             })
        //         );
        //         state.view.graph.container.appendChild(img);
        //         this.images.push(img);
        //     }
        // };

        // mxIconSet.prototype.destroy = function() {
        //     if (this.images != null) {
        //         for (var i = 0; i < this.images.length; i++) {
        //             var img = this.images[i];
        //             img.parentNode.removeChild(img);
        //         }
        //     }

        //     this.images = null;
        // };

        /*
         * Main function to initialize the mxgraph editor
         */
        function main(element) {
            // Defines an icon for creating new connections in the connection handler.
            // This will automatically disable the highlighting of the source vertex.
            // mxConnectionHandler.prototype.connectImage = new mxImage('/client/iotool/app/scripts/plugins/graph-editor/images/connector.gif', 16, 16);
            mxConstraintHandler.prototype.pointImage = new mxImage('/client/iotool/app/scripts/plugins/graph-editor/images/dot.gif', 10, 10);

            // Checks if browser is supported
            if (!mxClient.isBrowserSupported()) {
                // Displays an error message if the browser is
                // not supported.
                mxUtils.error('Browser is not supported!', 200, false);
            } else {
                // Creates the div for the toolbar
                var tbContainer = document.createElement('div');
                tbContainer.style.overflow = 'hidden';
                tbContainer.style.padding = '3px';
                tbContainer.style.height = '60px';
                tbContainer.style.width = '500px';
                tbContainer.style.margin = '0 auto';
                tbContainer.style.backgroundColor = 'rgba(255, 255, 255, 0.8)';

                element.appendChild(tbContainer);

                // Creates new toolbar without event processing
                var toolbar = new mxToolbar(tbContainer);
                toolbar.enabled = false


                // Creates the div for the graph
                container = document.createElement('div');
                container.style.overflow = 'scroll';
                container.style.height = "600px";
                container.style.background = 'url("/client/iotool/app/scripts/plugins/graph-editor/images/grid.png")';

                element.appendChild(container);

                // Workaround for Internet Explorer ignoring certain styles
                if (mxClient.IS_QUIRKS) {
                    document.body.style.overflow = 'hidden';
                    new mxDivResizer(tbContainer);
                    new mxDivResizer(container);
                }

                // Creates the model and the graph inside the container
                // using the fastest rendering available on the browser
                model = new mxGraphModel();
                graph = new mxGraph(container, model);
                graph.dropEnabled = true;


                // Matches DnD inside the graph
                mxDragSource.prototype.getDropTarget = function(graph, x, y) {
                    var cell = graph.getCellAt(x, y);
                    if (!graph.isValidDropTarget(cell)) {
                        cell = null;
                    }
                    return cell;
                };

                // Enables new connections in the graph
                graph.setConnectable(true);
                graph.setMultigraph(false);

                graph.setCellsDisconnectable(false);
                graph.setDisconnectOnMove(false);

                // Enables HTML labels
                graph.setHtmlLabels(true);

                graph.setPortsEnabled(false);

                // Enables tooltips
                graph.setTooltips(true);

                // var iconTolerance = 20;

                // Shows icons if the mouse is over a cell
                // graph.addMouseListener({
                //     currentState: null,
                //     currentIconSet: null,
                //     mouseDown: function(evt, state) {
                //         // Hides icons on mouse down
                //         if (state.sourceState) {
                //             if (this.currentIconSet == null) {
                //                 var forEdge = true;
                //                 this.currentIconSet = new mxIconSet(state.state, forEdge);
                //             }
                //         } else {
                //             if (this.currentIconSet != null) {
                //                 this.currentIconSet.destroy();
                //                 this.currentIconSet = null;
                //             }
                //         }
                //     },
                //     mouseMove: function(sender, me) {
                //         if (this.currentState != null && (me.getState() == this.currentState ||
                //                 me.getState() == null)) {
                //             var tol = iconTolerance;
                //             var tmp = new mxRectangle(me.getGraphX() - tol,
                //                 me.getGraphY() - tol, 2 * tol, 2 * tol);

                //             if (mxUtils.intersects(tmp, this.currentState)) {
                //                 return;
                //             }
                //         }
                //         var tmp = graph.view.getState(me.getCell());
                //         // Ignores everything but vertices
                //         if (graph.isMouseDown || (tmp != null && !graph.getModel().isVertex(tmp.cell))) {
                //             tmp = null;
                //         }
                //         if (tmp != this.currentState) {
                //             if (this.currentState != null) {
                //                 this.dragLeave(me.getEvent(), this.currentState);
                //             }
                //             this.currentState = tmp;
                //             if (this.currentState != null) {
                //                 this.dragEnter(me.getEvent(), this.currentState);
                //             }
                //         }
                //     },
                //     mouseUp: function(sender, me) {},
                //     dragEnter: function(evt, state) {
                //         if (this.currentIconSet == null) {
                //             this.currentIconSet = new mxIconSet(state);
                //         }
                //         var currentCell = state.cell;

                //         //Handle showing tooltips for Task, Decision and Status Changer 
                //         if (currentCell.style == "swimlane") {
                //             graph.getTooltipForCell = function() {
                //                 return null;
                //             }
                //         } else {
                //             graph.getTooltipForCell = function(currentCell) {
                //                 if (currentCell && currentCell.ioElement == 'task' && currentCell.workflowTask && currentCell.workflowTask.taskId) {
                //                     var text = getTaskDefinition_helper(currentCell.workflowTask.taskId);
                //                     if (text) {
                //                         return text;
                //                     } else {
                //                         return currentCell.value;
                //                     }
                //                 } else {
                //                     return currentCell.value;
                //                 }

                //             }
                //         }
                //     },
                //     dragLeave: function(evt, state) {
                //         if (this.currentIconSet != null) {
                //             this.currentIconSet.destroy();
                //             this.currentIconSet = null;
                //         }
                //     }
                // });


                //Disable Cell Resize
                //graph.cellsResizable = false;

                var mxConnectionHandlerUpdateEdgeState = mxConnectionHandler.prototype.updateEdgeState;
                mxConnectionHandler.prototype.updateEdgeState = function(pt, constraint) {
                    if (pt != null && this.previous != null) {
                        var constraints = this.graph.getAllConnectionConstraints(this.previous);
                        var nearestConstraint = null;
                        var dist = null;

                        for (var i = 0; i < constraints.length; i++) {
                            var cp = this.graph.getConnectionPoint(this.previous, constraints[i]);

                            if (cp != null) {
                                var tmp = (cp.x - pt.x) * (cp.x - pt.x) + (cp.y - pt.y) * (cp.y - pt.y);

                                if (dist == null || tmp < dist) {
                                    nearestConstraint = constraints[i];
                                    dist = tmp;
                                }
                            }
                        }

                        if (nearestConstraint != null) {
                            this.sourceConstraint = nearestConstraint;
                        }

                    }

                    mxConnectionHandlerUpdateEdgeState.apply(this, arguments);
                };

                // Disables floating connections (only use with no connect image)
                if (graph.connectionHandler.connectImage == null) {
                    graph.connectionHandler.isConnectableCell = function(cell) {
                        return false;
                    };
                    mxEdgeHandler.prototype.isConnectableCell = function(cell) {
                        return graph.connectionHandler.isConnectableCell(cell);
                    };
                }

                graph.getAllConnectionConstraints = function(terminal) {
                    if (terminal != null && this.model.isVertex(terminal.cell)) {
                        if (terminal.cell.style == 'swimlane') {
                            return null;
                        } else if (terminal.cell.style == 'shape=triangle') {
                            return [
                                new mxConnectionConstraint(new mxPoint(0, 0.5), true),
                                new mxConnectionConstraint(new mxPoint(1, 0.5), true)
                            ];
                        }
                        return [
                            new mxConnectionConstraint(new mxPoint(0.5, 0), true),
                            new mxConnectionConstraint(new mxPoint(0, 0.5), true),
                            new mxConnectionConstraint(new mxPoint(1, 0.5), true),
                            new mxConnectionConstraint(new mxPoint(0.5, 1), true)
                        ];
                    }

                    return null;
                };


                // graph.cellsResizable = false;

                // Stops editing on enter or escape keypress
                var keyHandler = new mxKeyHandler(graph);
                var rubberband = new mxRubberband(graph);

                /*
                    Handle cell create and geometries of cell 
                */
                var addVertex = function(icon, w, h, style, labelName) {
                    var vertex = new mxCell(labelName, new mxGeometry(0, 0, w, h), style);
                    vertex.setVertex(true);

                    addToolbarItem(graph, toolbar, vertex, icon);
                };

                addVertex('/client/iotool/app/scripts/plugins/graph-editor/images/Rectangle.png', 100, 40, 'shape=rectangle', 'Task');
                //addVertex('/client/iotool/app/scripts/plugins/graph-editor/images/rounded.gif', 100, 40, 'shape=rounded', 'Process');
                addVertex('/client/iotool/app/scripts/plugins/graph-editor/images/Rhombus.png', 75, 75, 'shape=rhombus', 'Decision');
                addVertex('/client/iotool/app/scripts/plugins/graph-editor/images/Triangle.png', 75, 75, 'shape=triangle', 'Status Changer');
                toolbar.addLine();
                // Handle graph zoom in
                toolbar.addItem('Zoom In', '/client/iotool/app/scripts/plugins/graph-editor/images/magnifying-glass-zoom-in.png', function(evt) {
                    graph.zoomIn();
                });

                // Handle graph zoom out
                toolbar.addItem('Zoom Out', '/client/iotool/app/scripts/plugins/graph-editor/images/magnifying-glass-zoom-out.png', function(evt) {
                    graph.zoomOut();
                });

                toolbar.addLine();
                // Handle graph zoom out
                toolbar.addItem('Save', '/client/iotool/app/scripts/plugins/graph-editor/images/save.png', function(evt) {
                    self.saveHelper();
                });

                graph.getStylesheet().putCellStyle('swimlane', style);
                graph.getStylesheet().getDefaultEdgeStyle()['edgeStyle'] = 'orthogonalEdgeStyle';
                graph.getStylesheet().getDefaultEdgeStyle()['verticalAlign'] = 'top';
                graph.getStylesheet().getDefaultEdgeStyle()['verticalLabelPosition'] = 'bottom';
                if (workflowData.hasIoGraph == "1" && workflowData.ioGraph) {
                    loadFromJSONData(workflowData.ioGraph);
                } else {
                    loadRoutingRuleSets(graph);
                }

            }
        }

        var addToolbarItem = (graph, toolbar, prototype, image) => {
            // Function that is executed when the image is dropped on
            // the graph. The cell argument points to the cell under
            // the mousepointer if there is one.
            var funct = (graph, evt, cell) => {
                graph.stopEditing(false);

                var pt = graph.getPointForEvent(evt);
                var vertex = graph.getModel().cloneCell(prototype);
                vertex.geometry.x = pt.x;
                vertex.geometry.y = pt.y;

                graph.setSelectionCells(graph.importCells([vertex], 0, 0, cell));
            }

            // Creates the image which is used as the drag icon (preview)
            var img = toolbar.addMode(prototype.value, image, funct);
            mxUtils.makeDraggable(img, graph, funct);
        };

        /*
        * Handle broadcast event for workflow initial status
        */
        var initialStatusVertex = $rootScope.$on('InitialWorkflowStatus', function(event, cell, initialObj) {
            initialStatus_helper(cell, initialObj);
        });

        /*
        * Handle Destroy an event
        */
        $rootScope.$on('$destroy', function() {
            initialStatusVertex();
        });


        /*
         * Handle inital status updates
         */
        var initialStatus_helper = (cell, formObj) => {

            //Need to update the logic updating the 1st routing rule set for now
            cell.outGoingAction = formObj.action;
            if (workflowData.routingRuleSets && workflowData.routingRuleSets.length) {
                workflowData.routingRuleSets[0].workflowActionId = formObj.action.id;
            }
            if (cell.edges) {
                _.each(cell.edges, function(edgeObj){
                    edgeObj.target.incomingAction = formObj.action;
                    _.each(edgeObj.target.edges, function(edge) {
                        if (edge.source.ioElement == 'changer' || edge.source.ioElement == 'condition') {
                            edge.target.incomingAction = formObj.action;
                        }
                    });
                });
            }
        }

        /*
        * Handle broadcast event for creating workflow task properties
        */
        var taskCreation = $rootScope.$on('addTaskToWorkflow', function(event, formObj, cell) {
            handleTask(event, formObj, cell);
        });

        /*
        * Handle Destroy an event
        */
        $rootScope.$on('$destroy', function() {
            taskCreation();
        });

        /*
         * Handle task create,update and new swimlane creation
         */
        var handleTask = (evt, formObj, cell) => {
            if (formObj.incomingAction) {
                cell.incomingAction = formObj.incomingAction;
            }
            if (cell.edges) {
                for (var i = 1, len = cell.edges.length; i < len; i++) {
                    cell.edges[i].target.incomingAction = formObj.outGoingAction;
                    cell.edges[i].target.outGoingAction = formObj.outGoingAction;
                    _.each(cell.edges[i].target.edges, function(edge) {
                        if (edge.source.ioElement == 'changer' || edge.source.ioElement == 'condition') {
                            edge.target.incomingAction = formObj.outGoingAction;
                        }
                    });
                }
            }
            cell.taskObj = formObj;
            cell.outGoingAction = formObj.outGoingAction;
            if (formObj.statusId == cell.parent.statusId) {
                // We wont change the swimlane of the task 
            } else {
                var swimlane_xaxis = cell.parent.geometry.x + 300;
                var swimlaneId = _.find(workflowData.swimlanes, function(list) {
                    return list.statusId == formObj.statusId;
                });
                if (swimlaneId) {
                    var swimlane = _.find(graph.model.cells, function(cell) {
                        return (cell.style == 'swimlane' && cell.statusId == swimlaneId.statusId);
                    });
                    cell.setParent(swimlane); //set parent to cell
                } else {
                    var parent = graph.getDefaultParent(); //get default parent
                    graph.getStylesheet().putCellStyle('swimlane', style);
                    model.beginUpdate();
                    try {
                        var swimlane_xaxis = alignSwimlane_helper();
                        var statusName = mapStatusName_helper(formObj.statusId);
                        //set parent to cell
                        var swimlane = graph.insertVertex(parent, null, statusName, swimlane_xaxis, 0, symbols.swimlane.width, symbols.swimlane.height, "swimlane");
                        swimlane.statusId = formObj.statusId;
                        cell.setParent(swimlane);
                        cell.routingRule.statusId = formObj.statusId;
                        workflowData.swimlanes.push(swimlane);
                    } finally {
                        // Updates the display
                        model.endUpdate();
                    }
                }
                if ((cell.geometry.x + cell.geometry.width) > swimlane.geometry.width) {
                    swimlane.geometry.width = (Math.ceil((cell.geometry.x + cell.geometry.width) / 10) * 10);
                    graph.refresh();
                }
            }
            if (formObj.task) {
                handleLabelText(cell, formObj.task.name);
            }
            cell.workflowTask.workflowActionId = formObj.outGoingAction.id;
            cell.workflowTask.routingRuleId = cell.routingRule._id;
            cell.workflowTask.taskId = formObj.task.id;
            cell.workflowTask.sequence = formObj.sequence;
            cell.workflowTask.autoAssign = formObj.auto_assign;
            cell.workflowTask.onDemand = formObj.onDemand;
            cell.workflowTask.shared = formObj.shared;

            refreshGraph(); //refresh graph
        };

        var handleDecisionBox = (cell, formObj) => {
            //cell.routingCondition.routingRuleSetId = (formObj.routingRuleSetId)?formObj.routingRuleSetId:null;
            cell.routingCondition.ruleSetId = (formObj.ruleSetId) ? formObj.ruleSetId : null;
            cell.routingCondition.trueRoutingRuleId = (formObj.trueRoutingRuleId) ? formObj.trueRoutingRuleId : null;
            cell.routingCondition.falseRoutingRuleId = (formObj.falseRoutingRuleId) ? formObj.falseRoutingRuleId : null;
            refreshGraph();
        };

        /**
         * Helper function to launch decision box when a decision box is connected to task
         * @param {*} element 
         */
        var launchDecisionBox = (element) => {
            self.modalShown = true;
            self.workflowData = workflowData;
            self.graphVertexTemplate = workFlowDecisionPropertiesHtmlUrl;
        }

        /*
        * Handle broadcast event for creating workflow status changer
        */
        var statusChangerVertex = $rootScope.$on('WorkflowStatusChanger', function(evt, formObj, cell) {
            handleStatusChange(evt, formObj, cell);
        });

        /*
        * Handle Destroy an event
        */
        $rootScope.$on('$destroy', function() {
            statusChangerVertex();
        });

        /*
         * Handle status change and new swimlane creation
         */
        var handleStatusChange = (evt, formObj, cell) => {
            if (formObj.incomingAction) {
                cell.incomingAction = formObj.incomingAction;
            }
            if (cell.edges) {
                _.each(cell.edges, function(edge) {
                    if (edge.source.ioElement == 'changer') {
                        edge.target.incomingAction = cell.outGoingAction;
                    } else {
                        edge.source.outGoingAction = formObj.incomingAction;
                    }
                });
            }
            cell.taskObj = formObj;
            //cell.outGoingAction = formObj.outGoingAction;
            if (formObj.newStatusId == cell.parent.statusId) {
                // We wont change the swimlane of the task 
            } else {
                //var swimlane_xaxis = cell.parent.geometry.x + 300;
                var swimlaneId = _.find(workflowData.swimlanes, function(list) {
                    return list.statusId == formObj.newStatusId;
                });
                if (swimlaneId) {
                    var swimlane = _.find(graph.model.cells, function(cell) {
                        return (cell.style == 'swimlane' && cell.newStatusId == swimLaneId);
                    });
                    cell.setParent(swimlane); //set parent to cell
                } else {
                    var parent = graph.getDefaultParent(); //get default parent
                    graph.getStylesheet().putCellStyle('swimlane', style);
                    model.beginUpdate();
                    try {
                        var swimlane_xaxis = alignSwimlane_helper();
                        var statusName = mapStatusName_helper(formObj.newStatusId);
                        //set parent to cell
                        var graphInst = graph.insertVertex(parent, null, statusName, swimlane_xaxis, 0, symbols.swimlane.width, symbols.swimlane.height, "swimlane");
                        graphInst.statusId = formObj.newStatusId;
                        cell.newStatusId = formObj.newStatusId;
                        cell.setParent(graphInst);
                        cell.routingRule.statusId = formObj.newStatusId;
                        workflowData.swimlanes.push(graphInst);
                        handleLabelText(cell, statusName);
                    } finally {
                        // Updates the display
                        model.endUpdate();
                    }
                }


            }
            refreshGraph(); //refresh graph
        }

        /*
         * handle showing label text and shrink the label text
         */
        var handleLabelText = (cell, labelName) => {
            //var cell = evt.properties.cell;
            // Truncates the label to the size of the vertex
            graph.getLabel = function(cell) {
                var label = (this.labelsVisible) ? this.convertValueToString(cell) : '';
                var geometry = this.model.getGeometry(cell);

                if (!this.model.isCollapsed(cell) && geometry != null && (geometry.offset == null ||
                        (geometry.offset.x == 0 && geometry.offset.y == 0)) && this.model.isVertex(cell) &&
                    geometry.width >= 2) {
                    var style = this.getCellStyle(cell);
                    var fontSize = style[mxConstants.STYLE_FONTSIZE] || mxConstants.DEFAULT_FONTSIZE;
                    var max = geometry.width / (fontSize * 0.625);

                    if (max < label.length) {
                        return label.substring(0, max) + '...';
                    }
                }

                return label;
            };

            //set label value for cell
            graph.model.setValue(cell, labelName);
        }

        /* 
         *   Handle properties of task, decision and status changer 
         */
        var handleClickEvent = (sender, evt) => {
            var cell = evt.getProperty("cell");
            if (cell && (cell.style == 'swimlane' || cell.style == 'shape=link')) {

            } else {
                graph.getSelectionModel().clear();
            }
            if (cell != null) {
                if (cell.vertex != null && cell.vertex == 1 && !graph.isSwimlane(cell)) {
                    self.cell = cell;
                    switch (cell.style) {
                        case 'shape=rectangle':
                            if (cell.value == 'Client' || cell.value == 'Order' || cell.value == 'Lineitem') {
                                self.modalShown = true;
                                self.graphVertexTemplate = initialStatusHtmlUrl;
                            } else {
                                self.modalShown = true;
                                self.graphVertexTemplate = workFlowTaskPropertiesHtmlUrl;
                            }
                            break;
                        case 'shape=rhombus':
                            launchDecisionBox(cell);
                            break;
                        case 'shape=triangle':
                            self.graphVertexTemplate = wfStatusChangerPropertiesHtmlUrl;
                            self.modalShown = true;
                            break;
                        default:
                            // Need to add the default logic                           
                    }
                }
            }
            evt.consume();
        };

        /*
        * Handle broadcast event for creating workflow Decision Properties
        */
        var DecisionVertex = $rootScope.$on('WorkflowDecision', function(evt, formObj, cell) {
            if (cell.edge) {
                cell.value = formObj.decision;
                cell.target.incomingAction = populateData_helper(self.workflowObj.workflowActions, { id: cell.source.routingRuleSet.workflowActionId });
                handleDecisionBox(cell.source, formObj);
            } else {
                handleDecisionBox(cell, formObj);
            }
        });

        /*
        * Handle Destroy an event
        */
        $rootScope.$on('$destroy', function() {
            DecisionVertex();
        });

        // graph refresh after modify
        var refreshGraph = () => {
            graph.refresh();
        }

        /*
         * Helper function to populate the drop downs
         * @param: arr - Array list of the dropdown
         * @param: obj - to be populated object
         */
        function populateData_helper(arr, obj) {
            return _.find(arr, function(item) {
                return item.id == obj.id
            })
        }

        /*
         * Helper function to check if the rule set is already created and return the ruleset
         * @param {id} id of the siwmlane to check if the rule set is created
         */
        var routingRuleSets_helper = (status_id, routingRuleSetData = null, actionId) => {
            var index = _.findIndex(workflowData.routingRuleSets, function(ruleSet) {
                return ruleSet.statusId == status_id;
            });
            if (index >= 0) {
                return workflowData.routingRuleSets[index];
            } else {
                var routingRuleSetObj = new RoutingRuleSet(null, workflowData.id, null, status_id);
                if (routingRuleSetData) {
                    routingRuleSetObj.id = routingRuleSetData.id;
                    if (routingRuleSetData.workflowId) {
                        routingRuleSetObj.workflowId = routingRuleSetData.workflowId;
                        routingRuleSetObj.workflowActionId = routingRuleSetData.workflowActionId;
                        routingRuleSetObj.statusId = (routingRuleSetData.statusId) ? routingRuleSetData.statusId : null;
                        routingRuleSetObj.automated = (routingRuleSetData.automated) ? routingRuleSetData.automated : null;
                    } else {
                        routingRuleSetObj.workflowId = routingRuleSetData.workflow_id;
                        routingRuleSetObj.workflowActionId = routingRuleSetData.workflow_action_id;
                        routingRuleSetObj.statusId = (routingRuleSetData.status_id) ? routingRuleSetData.status_id : null;
                        routingRuleSetObj.automated = (routingRuleSetData.automated) ? routingRuleSetData.automated : null;
                    }
                }
                if (actionId) {
                    routingRuleSetObj.workflowActionId = actionId;
                }
                workflowData.routingRuleSets.push(routingRuleSetObj);
                return routingRuleSetObj;
            }
        };

        /*
         * Helper function to check if the rule is already created and return the rule
         * @param {id} id of the siwmlane to check if the rule is created
         */
        var routingRules_helper = (statusId, ruleSetId, routingRuleData = null) => {
            if (routingRuleData !== null) {
                var routingRule = _.find(workflowData.routingRules, { id: routingRuleData.id });
                if (routingRule) {
                    return routingRule;
                } else {
                    if (routingRuleData.routingRuleSetId) {
                        var routingRule = new RoutingRule(routingRuleData.id, routingRuleData.routingRuleSetId, routingRuleData.statusId, routingRuleData.defaultRule, routingRuleData.workflowStepId);
                    } else {
                        var routingRule = new RoutingRule(routingRuleData.id, routingRuleData.routing_rule_set_id, routingRuleData.status_id, routingRuleData.default_rule, routingRuleData.workflow_step_id);
                    }
                    workflowData.routingRules.push(routingRule);
                    return routingRule;
                }
            }
            var routingRule = new RoutingRule(null, ruleSetId, statusId);
            workflowData.routingRules.push(routingRule);
            return routingRule;
        };

        /**
         * Helper function to check if the workflow task is already created and return the task
         * @param {*} statusId
         * @param {*} ruleId 
         */
        var workflowTasks_helper = (statusId, ruleId, workflowTaskData = null) => {
            if (workflowTaskData !== null) {
                var workflowTask = _.find(workflowData.workflowTasks, { id: workflowTaskData.id });
                if (workflowTask) {
                    return workflowTask;
                }
            }
            var workflowTask = new WorkflowTask(null, workflowData.id, null, ruleId);
            if (workflowTaskData !== null) {
                workflowTask.id = workflowTaskData.id;
                if (workflowTaskData.workflowId) {
                    workflowTask.workflowId = workflowTaskData.workflowId;
                    workflowTask.workflowActionId = workflowTaskData.workflowActionId;
                    workflowTask.routingRuleId = workflowTaskData.routingRuleId;
                    workflowTask.taskId = workflowTaskData.taskId;
                    workflowTask.sequence = workflowTaskData.sequence;
                    workflowTask.autoAssign = workflowTaskData.autoAssign;
                    workflowTask.shared = workflowTaskData.shared;
                    workflowTask.onDemand = workflowTaskData.onDemand;
                } else {
                    workflowTask.workflowId = workflowTaskData.workflow_id;
                    workflowTask.workflowActionId = workflowTaskData.workflow_action_id;
                    workflowTask.routingRuleId = workflowTaskData.routing_rule_id;
                    workflowTask.taskId = workflowTaskData.task_id;
                    workflowTask.sequence = workflowTaskData.sequence;
                    workflowTask.autoAssign = workflowTaskData.auto_assign;
                    workflowTask.shared = workflowTaskData.shared;
                    workflowTask.onDemand = workflowTaskData.on_demand;
                }
            }
            workflowData.workflowTasks.push(workflowTask);
            return workflowTask;
        };

        /*
         * Helper function to check if the rule is already created and return the rule
         * @param {id} id of the siwmlane to check if the rule is created
         */
        var routingConditions_helper = (routingRuleSetId, routingConditionData = null) => {

            var routingCondition = new RoutingCondition(null, routingRuleSetId);
            if (routingConditionData) {
                routingCondition.id = routingConditionData.id;
                if (routingConditionData.ruleSetId) {
                    routingCondition.ruleSetId = routingConditionData.ruleSetId;
                    routingCondition.trueRoutingRuleId = routingConditionData.trueRoutingRuleId;
                    routingCondition.falseRoutingRuleId = routingConditionData.falseRoutingRuleId;
                } else {
                    routingCondition.ruleSetId = routingConditionData.rule_set_id;
                    routingCondition.trueRoutingRuleId = routingConditionData.true_routing_rule_id;
                    routingCondition.falseRoutingRuleId = routingConditionData.false_routing_rule_id;
                }
            }
            workflowData.routingConditions.push(routingCondition);
            return routingCondition;
        };

        // calculate new swimlane positions.
        var alignSwimlane_helper = () => {
            var swimlane_xaxis = 0;
            _.each(workflowData.swimlanes, function(swimlaneObj) {
                swimlaneObj.geometry.x = swimlane_xaxis;
                swimlane_xaxis += swimlaneObj.geometry.width;
            });
            refreshGraph();
            return swimlane_xaxis;
        }

        var getRoutingRuleCells_helper = (parentObj, routingRuleId) => {
            return _.filter(graph.getChildVertices(parentObj), function(cell) {
                return (cell.routingRule && cell.routingRule.id == routingRuleId);
            });
        }

        var getTaskDefinition_helper = (taskId) => {
            var obj = _.find(self.workflowObj.tasksList, function(task) {
                return (task.id == taskId);
            });
            if (obj) {
                return obj.definition;
            } else {
                return "";
            }

        }

        /*
         * Edge validation helper, return true if its a valid edge
         */
        var edge_validation = (element, from) => {
            switch (from) {
                case 'task':
                case 'changer':
                    if (element.source && element.source.outGoingAction && element.source.outGoingAction.id) {
                        return true;
                    }
                    break;
                case 'condition':
                    if (element.source && element.source.incomingAction && element.source.incomingAction.id) {
                        return true;
                    }
                    break;
            }
            return false;
        }

        /*
         * Handles the backgroud object creation for routing rule sets, rules and tasks
         */
        var handleDropEvent = (sender, evt) => {
            if (evt && evt.properties && evt.properties.cells && evt.properties.cells.length) {
                var element = evt.properties.cells[0];
                switch (element.style) {
                    case 'shape=rectangle':
                        element.routingRuleSet = routingRuleSets_helper(evt.properties.parent.statusId);
                        element.routingRule = routingRules_helper(evt.properties.parent.statusId, element.routingRuleSet._id);
                        element.workflowTask = workflowTasks_helper(evt.properties.parent.statusId, element.routingRule._id);
                        element.ioElement = 'task';
                        break;
                    case 'shape=rhombus':
                        element.routingRuleSet = routingRuleSets_helper(evt.properties.parent.statusId);
                        element.routingCondition = routingConditions_helper(element.routingRuleSet._id);
                        element.ioElement = 'condition';
                        break;
                    case 'swimlane':
                        break;
                    case 'shape=triangle':
                        element.routingRule = routingRules_helper(evt.properties.parent.statusId, '');
                        element.ioElement = 'changer';
                        break;
                    default:
                        // Need to update the logic more correctly
                        switch (element.source.ioElement) {
                            case 'task':
                                // Validate if the edge can be created or not, We will create the edge only if the source task has an outgoing action set
                                if (!edge_validation(element, "task")) {
                                    graph.getModel().remove(element);
                                    $ioAlert.show('Error!', 'Edge source task must have outging action', 'error');
                                    return false;
                                }
                                if (element.target && element.target.routingRuleSet) {
                                    var rSIndex = _.findIndex(workflowData.routingRuleSets, function(ruleSet) {
                                        return ruleSet._id == element.target.routingRuleSet._id;
                                    });
                                    workflowData.routingRuleSets[rSIndex].workflowActionId = element.target.routingRuleSet.workflowActionId = element.source.outGoingAction.id;
                                }
                                element.target.incomingAction = element.source.outGoingAction;
                                //For status changer we need incoming statusid
                                if (element.target.ioElement == 'changer') {
                                    element.target.incomingStatus = element.source.parent.statusId;
                                    element.target.routingRuleSet = routingRuleSets_helper(element.target.parent.statusId, null, element.target.incomingAction.id);
                                    element.target.routingRule.routingRuleSetId = element.target.routingRuleSet._id;
                                    element.target.outGoingAction = element.target.incomingAction
                                }
                                if (element.target.ioElement == 'condition') {
                                    element.target.outGoingAction = element.target.incomingAction
                                }
                                break;
                            case 'condition':
                                if (!edge_validation(element, 'condition')) {
                                    graph.getModel().remove(element);
                                    $ioAlert.show('Error!', 'Decision box must have outging action', 'error');
                                    return false;
                                }
                                element.target.routingRule.routingRuleSetId = element.source.routingRuleSet._id;
                                //When user connects decision box to a task launch the decisionModal and show and ask the user to select true or false routing rule
                                launchDecisionBox(element);
                                //For status changer we need incoming statusid
                                if (element.target.ioElement == 'changer') {
                                    element.target.incomingStatus = element.source.parent.statusId;
                                    element.target.routingRule.routingRuleSetId = element.source.RoutingRuleSet._id;
                                }
                                break;
                            case 'changer':
                                if (!edge_validation(element, "changer")) {
                                    graph.getModel().remove(element);
                                    $ioAlert.show('Error!', 'Edge source task must have outging action', 'error');
                                    return false;
                                }
                                if (element.target && element.target.routingRuleSet) {
                                    var rSIndex = _.findIndex(workflowData.routingRuleSets, function(ruleSet) {
                                        return ruleSet._id == element.target.routingRuleSet._id;
                                    });
                                    workflowData.routingRuleSets[rSIndex].workflowActionId = element.target.routingRuleSet.workflowActionId = element.source.outGoingAction.id;
                                }
                                element.target.incomingAction = element.source.outGoingAction;
                                break;

                        }

                }
                alignSwimlane_helper();
            }
        }

        // Load Swimline
        var loadRoutingRuleSets = (graph) => {
            //var model = graph.getModel();
            var parent = graph.getDefaultParent();
            var sourceEdgeCellObj = null;
            if (self.workflowObj.workflowInfo) {
                var routingRuleSet = _.find(self.workflowObj.routingRuleSets, { status_id: self.workflowObj.workflowInfo.initial_status_id });
                var swimlaneObj = graph.insertVertex(parent, null, self.workflowObj.workflowInfo.initial_status_name, 0, 0, symbols.swimlane.width, symbols.swimlane.height, "swimlane");
                swimlaneObj.statusId = self.workflowObj.workflowInfo.initial_status_id;
                swimlaneObj.routingRuleSet = routingRuleSets_helper(swimlaneObj.statusId, routingRuleSet);
                workflowData.swimlanes.push(swimlaneObj);
                var startX = 10;
                var startY = parseInt((symbols.swimlane.height - symbols.rectangle.height) / 2);
                startY = startY - (startY % 10);
                var initVertexObj = graph.insertVertex(swimlaneObj, null, self.workflowObj.workflowInfo.workflow_type_name, startX, startY, symbols.rectangle.width, symbols.rectangle.height, "shape=rectangle");
                initVertexObj.ioElement = 'task';
                initVertexObj.outGoingAction = _.find(self.workflowObj.workflowActions, { id: "1" });
                sourceEdgeCellObj = initVertexObj;
            }

            // Existing workflows
            if (self.workflowObj.routingRuleSets && self.workflowObj.routingRuleSets.length > 0) {
                _.each(self.workflowObj.routingRuleSets, function(routingRuleSet) {

                    _.each(routingRuleSet.routingRules, function(routingRule) {
                        var swimlane_xaxis = alignSwimlane_helper();
                        var existSwimlanes = _.find(workflowData.swimlanes, { statusId: routingRule.status_id });
                        if (self.workflowObj.workflowInfo.initial_status_id == routingRule.status_id || existSwimlanes) {
                            //var swimlaneObj = _.find(workflowData.swimlanes, { statusId: routingRuleSet.status_id });
                        } else {
                            var swimlaneObj = graph.insertVertex(parent, null, mapStatusName_helper(routingRule.status_id), swimlane_xaxis, 0, symbols.swimlane.width, symbols.swimlane.height, "swimlane");
                            swimlaneObj.statusId = routingRule.status_id;
                            swimlaneObj.routingRuleSet = routingRuleSets_helper(routingRuleSet.status_id, routingRuleSet);
                            workflowData.swimlanes.push(swimlaneObj);
                        }
                    });
                });
                _.each(self.workflowObj.routingRuleSets, function(routingRuleSet) {
                    var startX = 140;
                    var startY = 80;
                    if (routingRuleSet.routingRules && self.workflowObj.workflowTasks) {
                        _.each(routingRuleSet.routingRules, function(routingRule) {
                            var swimlaneObj = _.find(workflowData.swimlanes, { statusId: routingRule.status_id });
                            var routingRuleWorkflowTasks = _.filter(self.workflowObj.workflowTasks, function(workflowTask) { return (workflowTask.routing_rule_id == routingRule.id) });
                            if (routingRuleWorkflowTasks && routingRuleWorkflowTasks.length > 0) {
                                _.each(routingRuleWorkflowTasks, function(workflowTask) {
                                    var vertexObj = graph.insertVertex(swimlaneObj, null, workflowTask.name, startX, startY, symbols.rectangle.width, symbols.rectangle.height, "shape=rectangle");
                                    vertexObj.ioElement = 'task';
                                    vertexObj.routingRule = routingRules_helper(routingRule.status_id, routingRuleSet._id, routingRule);
                                    vertexObj.workflowTask = workflowTasks_helper(routingRule.status_id, routingRule._id, workflowTask);
                                    vertexObj.outGoingAction = _.find(self.workflowObj.workflowActions, { id: workflowTask.workflow_action_id });
                                    handleLabelText(vertexObj, workflowTask.name);
                                    startY += 80;
                                });
                            } else {
                                var vertexObj = graph.insertVertex(swimlaneObj, null, mapStatusName_helper(routingRule.status_id), startX, startY, symbols.triangle.width, symbols.triangle.height, "shape=triangle");
                                vertexObj.ioElement = 'changer';
                                vertexObj.routingRule = routingRules_helper(routingRule.status_id, (routingRuleSet.id ? routingRuleSet.id : routingRuleSet._id), routingRule);
                                vertexObj.incomingStatus = routingRuleSet.status_id;
                                vertexObj.outGoingAction = _.find(self.workflowObj.workflowActions, { id: routingRuleSet.workflow_action_id });
                                startY += 80;
                            }
                        });
                    }
                });
                _.each(self.workflowObj.routingRuleSets, function(routingRuleSet) {
                    if (routingRuleSet.routingConditions && routingRuleSet.routingConditions.length > 0) {
                        _.each(routingRuleSet.routingConditions, function(routingCondition) {
                            if (routingCondition.true_routing_rule_id) {
                                var routingRule = _.find(workflowData.routingRules, { id: routingCondition.true_routing_rule_id });
                                var swimlaneObj = _.find(workflowData.swimlanes, { statusId: routingRule.statusId });
                            } else if (routingCondition.false_routing_rule_id) {
                                var routingRule = _.find(workflowData.routingRules, { id: routingCondition.false_routing_rule_id });
                                var swimlaneObj = _.find(workflowData.swimlanes, { statusId: routingRule.statusId });
                            }
                            if (!swimlaneObj) {
                                var swimlaneObj = _.find(workflowData.swimlanes, { statusId: routingRuleSet.status_id });
                            }
                            var vertexObj = graph.insertVertex(swimlaneObj, null, "Decision", startX, startY, symbols.rhombus.width, symbols.rhombus.height, "shape=rhombus");
                            vertexObj.ioElement = 'condition';
                            vertexObj.routingRuleSet = routingRuleSets_helper(routingRuleSet.status_id, routingRuleSet);
                            vertexObj.routingCondition = routingConditions_helper((vertexObj.routingRuleSet.id ? vertexObj.routingRuleSet.id : vertexObj.routingRuleSet._id), routingCondition);
                            startY += 100;
                            if (sourceEdgeCellObj.outGoingAction) {
                                vertexObj.incomingAction = sourceEdgeCellObj.outGoingAction;
                            }
                            var edgeObj = graph.insertEdge(parent, null, "", sourceEdgeCellObj, vertexObj, 'shape=link');
                            cell = _.find(graph.getChildVertices(swimlaneObj), function(cell) {
                                return (cell.routingRule && cell.routingRule.id == routingCondition.true_routing_rule_id);
                            });
                            sourceEdgeCellObj = cell;

                            var cells = getRoutingRuleCells_helper(swimlaneObj, vertexObj.routingCondition.trueRoutingRuleId);
                            _.each(cells, function(cell, itemIndex) {
                                if (itemIndex == 0) {
                                    cell.geometry.x = vertexObj.geometry.x + 20;
                                    cell.geometry.y = vertexObj.geometry.y - (Math.ceil((vertexObj.geometry.height / 2) / 10) * 10) - 60;
                                    cell.incomingAction = populateData_helper(self.workflowObj.workflowActions, { id: routingRuleSet.workflow_action_id });
                                    var edgeObj = graph.insertEdge(parent, null, 'True', vertexObj, cell, 'shape=link');
                                } else {
                                    var prevCell = cells[itemIndex - 1];
                                    cell.geometry.x = prevCell.geometry.x + prevCell.geometry.width + 20;
                                    cell.geometry.y = prevCell.geometry.y;
                                    cell.incomingAction = populateData_helper(self.workflowObj.workflowActions, { id: routingRuleSet.workflow_action_id });
                                    var edgeObj = graph.insertEdge(parent, null, '', prevCell, cell, 'shape=link');
                                }
                            });
                            var cells = getRoutingRuleCells_helper(swimlaneObj, vertexObj.routingCondition.falseRoutingRuleId);
                            _.each(cells, function(cell, itemIndex) {
                                if (itemIndex == 0) {
                                    cell.geometry.x = vertexObj.geometry.x + 20;
                                    cell.geometry.y = vertexObj.geometry.y + vertexObj.geometry.height + 60;
                                    cell.incomingAction = populateData_helper(self.workflowObj.workflowActions, { id: routingRuleSet.workflow_action_id });
                                    var edgeObj = graph.insertEdge(parent, null, 'False', vertexObj, cell, 'shape=link');
                                } else {
                                    var prevCell = cells[itemIndex - 1];
                                    cell.geometry.x = prevCell.geometry.x + prevCell.geometry.width + 20;
                                    cell.geometry.y = prevCell.geometry.y;
                                    cell.incomingAction = populateData_helper(self.workflowObj.workflowActions, { id: routingRuleSet.workflow_action_id });
                                    var edgeObj = graph.insertEdge(parent, null, '', prevCell, cell, 'shape=link');
                                }
                            });
                        });
                        graph.refresh();
                    } else {
                        if (sourceEdgeCellObj && routingRuleSet.routingRules && routingRuleSet.routingRules.length > 0) {
                            var swimlaneObj = _.find(workflowData.swimlanes, { statusId: routingRuleSet.routingRules[0].status_id });
                            var cell = _.find(graph.getChildVertices(swimlaneObj), function(cell) {
                                return (cell.routingRule && cell.routingRule.id == routingRuleSet.routingRules[0].id);
                            });
                            if (cell && sourceEdgeCellObj != cell) {
                                if (sourceEdgeCellObj.outGoingAction) {
                                    cell.incomingAction = sourceEdgeCellObj.outGoingAction;
                                }
                                var edgeObj = graph.insertEdge(parent, null, "", sourceEdgeCellObj, cell, 'shape=link');
                                sourceEdgeCellObj = cell;
                            }
                        }
                    }

                });
            }

        }

        /*
         * Load from json data
         */
        var loadFromJSONData = (ioGraph) => {

            var ioGraphCells = CircularJSON.parse(ioGraph);
            ioGraphCells = Array.from(Object.keys(ioGraphCells), k => ioGraphCells[k]);
            ioGraphCells.shift();
            ioGraphCells.shift();
            var parent = graph.getDefaultParent();

            _.each(ioGraphCells, function(cellObj) {
                if (cellObj.vertex && cellObj.style == 'swimlane') {
                    var swimlane_xaxis = alignSwimlane_helper();
                    var swimlane_width = (cellObj.geometry && cellObj.geometry.width) ? cellObj.geometry.width : symbols.swimlane.width;
                    var swimlaneObj = graph.insertVertex(parent, null, mapStatusName_helper(cellObj.statusId), swimlane_xaxis, 0, swimlane_width, symbols.swimlane.height, "swimlane");
                    swimlaneObj.statusId = cellObj.statusId;
                    swimlaneObj.routingRuleSet = routingRuleSets_helper(cellObj.statusId, cellObj.routingRuleSet);
                    workflowData.swimlanes.push(swimlaneObj);
                    cellObj.newId = swimlaneObj.id;
                }
            });
            _.each(ioGraphCells, function(cellObj) {
                if (cellObj.vertex) {
                    switch (cellObj.style) {
                        case 'shape=rectangle':
                            if (cellObj.workflowTask) {
                                var swimlaneObj = _.find(workflowData.swimlanes, { statusId: cellObj.routingRule.statusId });
                                var vertexObj = graph.insertVertex(swimlaneObj, null, cellObj.value, cellObj.geometry.x, cellObj.geometry.y, cellObj.geometry.width, cellObj.geometry.height, "shape=rectangle");
                                vertexObj.ioElement = 'task';
                                vertexObj.routingRule = routingRules_helper(cellObj.routingRule.statusId, cellObj.routingRule.routingRuleSetId, cellObj.routingRule);
                                vertexObj.workflowTask = workflowTasks_helper(cellObj.routingRule.statusId, cellObj.routingRule.id, cellObj.workflowTask);
                                vertexObj.outGoingAction = _.find(self.workflowObj.workflowActions, { id: cellObj.workflowTask.workflowActionId });
                            } else {
                                var swimlaneObj = _.find(workflowData.swimlanes, { statusId: self.workflowObj.workflowInfo.initial_status_id });
                                var vertexObj = graph.insertVertex(swimlaneObj, null, cellObj.value, cellObj.geometry.x, cellObj.geometry.y, cellObj.geometry.width, cellObj.geometry.height, "shape=rectangle");
                                vertexObj.ioElement = 'task';
                                vertexObj.outGoingAction = _.find(self.workflowObj.workflowActions, { id: cellObj.outGoingAction.id });
                            }
                            handleLabelText(vertexObj, cellObj.value);
                            cellObj.newId = vertexObj.id;
                            break;
                        case 'shape=rhombus':
                            var swimlaneObj = _.find(workflowData.swimlanes, { statusId: cellObj.routingRuleSet.statusId });
                            var vertexObj = graph.insertVertex(swimlaneObj, null, "Decision", cellObj.geometry.x, cellObj.geometry.y, cellObj.geometry.width, cellObj.geometry.height, "shape=rhombus");
                            vertexObj.ioElement = 'condition';
                            vertexObj.routingRuleSet = routingRuleSets_helper(cellObj.routingRuleSet.statusId, cellObj.routingRuleSet);
                            vertexObj.routingCondition = routingConditions_helper((vertexObj.routingRuleSet.id ? vertexObj.routingRuleSet.id : vertexObj.routingRuleSet._id), cellObj.routingCondition);
                            cellObj.newId = vertexObj.id;
                            break;
                        case 'shape=triangle':
                            var swimlaneObj = _.find(workflowData.swimlanes, { statusId: cellObj.routingRule.statusId });
                            var vertexObj = graph.insertVertex(swimlaneObj, null, "Status", cellObj.geometry.x, cellObj.geometry.y, cellObj.geometry.width, cellObj.geometry.height, "shape=triangle");
                            vertexObj.ioElement = 'changer';
                            if (cellObj.routingRuleSet) {
                                vertexObj.routingRuleSet = routingRuleSets_helper(cellObj.routingRuleSet.statusId, cellObj.routingRuleSet);
                            }
                            if (cellObj.incomingStatus) {
                                vertexObj.incomingStatus = cellObj.incomingStatus;
                            }
                            vertexObj.routingRule = routingRules_helper(cellObj.routingRule.statusId, cellObj.routingRule.routingRuleSetId, cellObj.routingRule);
                            cellObj.newId = vertexObj.id;
                            break;
                    }
                }
            });

            _.each(ioGraphCells, function(cellObj) {
                if (cellObj.edge) {
                    var sourceCell = graph.getModel().getCell(cellObj.source.newId);
                    var targetCell = graph.getModel().getCell(cellObj.target.newId);
                    if (sourceCell && targetCell) {
                        if (sourceCell.outGoingAction) {
                            targetCell.incomingAction = sourceCell.outGoingAction;
                            if (targetCell.ioElement == 'changer' || targetCell.ioElement == 'condition') {
                                targetCell.outGoingAction = targetCell.incomingAction;
                            }
                        }
                        graph.insertEdge(parent, null, "", sourceCell, targetCell, 'shape=link');
                    }
                }
            });

            graph.refresh();
        }

        /*
         *   Handle Cells move event with in swimlane and between swimlanes
         */
        var handleCellMoveEvent = (sender, evt) => {
            var cellMoveObj = evt.properties.cells[0];
            if (cellMoveObj.taskObj) {
                cellMoveObj.taskObj.statusId = cellMoveObj.parent.statusId;
            }
        }

        /*
         *   Handle cell selectable for graph symbols
         */
        var handleCellClickEvent = (sender, evt) => {
            var cell = evt.getProperty('cell');
            if (cell && (cell.style == 'swimlane' || cell.style == 'shape=link')) {

            } else {
                graph.getSelectionModel().clear();
            }
        }

        //function call to load document
        main(document.getElementById('graphContainer'));

        //event listener for double click
        // graph.addListener(mxEvent.DOUBLE_CLICK, handleDoubleClick);

        //event listener for cells add
        graph.addListener(mxEvent.CELLS_ADDED, handleDropEvent);

        // event listener for cells move
        graph.addListener(mxEvent.MOVE_CELLS, handleCellMoveEvent);

        //event listener for click
        // graph.addListener(mxEvent.CLICK, handleCellClickEvent);
        graph.addListener(mxEvent.CLICK, handleClickEvent);

        /* 
         * Initialize the component
         */
        // var initComponent = () => {
        //   console.log(self.workflowObj);
        // };
        //initComponent();
    },
    controllerAs: 'self'
});